import script from "./FileTableItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FileTableItem.vue?vue&type=script&setup=true&lang=js"

import "./FileTableItem.vue?vue&type=style&index=0&id=211cd5fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-211cd5fa"]])

export default __exports__